<script>
	import {Container, Row, Col} from 'svelte-materialify';
	import watchMedia from "svelte-media";

	const mediaqueries = {
	small: "(max-width: 849px)",
	large: "(min-width: 850px)",
	short: "(max-height: 399px)",
	//landscape: "(orientation: landscape) and (max-height: 499px)",
	landscape: "(orientation: landscape)",
	tiny: "(orientation: portrait) and (max-height: 599px)",
	dark: "(prefers-color-scheme: dark)",
	noanimations: "(prefers-reduced-motion: reduce)"
	};
	const media = watchMedia(mediaqueries);
</script>


<div class="container" style={$media.landscape ? "padding-top:38vh;" : "padding-top:27vw;"}>
	<div class="header" style={$media.landscape ? "" : "font-size:16vw;height:21vw;"}>
		JudoContest
	</div>

	<Container noGutters>
		<Row>
			<Col style="text-align: -webkit-center;">
				<div class="box" style={$media.landscape ? "" : "font-size:3vh;height:30vh;width:30vh;"} on:click={() => { window.location.href = "https://judocontest.com:222"; }}>
					ente organizzatore
				</div>
			</Col>
			<Col style="text-align: -webkit-center;">
				<div class="box" style={$media.landscape ? "" : "font-size:3vh;height:30vh;width:30vh;"} on:click={() => { window.location.href = "https://judocontest.com:333"; }}>
					società sportiva
				</div>
			</Col>
		</Row>
	</Container>

	<div class="footer" style={$media.landscape ? "" : "font-size:7vw;"} on:click={() => { window.location.href = "https://judocontest.com/prj"; }}>
		project info
	</div>
</div>

	
	
	
<style>
:global(body) {
	padding:0px;
}
.container {
	background-image: url("https://judocontest.com:854/img/judoamicizia8.jpg");
	background-size: cover;
	width: 100vw;
	height: 100vh;
}
.header {
	position: fixed;
	top:0px;
	left:0px;
	background-color: white;
	opacity: 0.8;

	font-size: 20vh;
	font-weight: 800;

	-webkit-text-stroke-width: 3px;
    -webkit-text-stroke-color: black;

	display: flex;
	justify-content: center;
	align-items: end;
	height: 26vh;
	width: 100vw;
	border: 0px solid black;
	color: white;
}

.footer {
	position: fixed;
	bottom: 0;
	_top:92vh;
	left:0px;
	background-color: white;
	opacity: 0.8;

	font-size: 6vh;
	font-weight: 100;
	/*
	-webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: darkorange;
	*/
	display: flex;
	justify-content: center;
	align-items: center;
	height: 8vh;
	width: 100vw;
	border: 0px solid black;
	color: black;

	cursor: pointer;
}
.box {
	background-color: white;
	border-radius:15px;
	opacity: 0.8;

	display: flex;
	justify-content: center;
	align-items: center;
	height: 32vh;
	width: 32vh;
	border: 2px solid black;
	color: black;

	font-size: 5vh;
	font-weight: 100;
}
.box:hover {
	color: white;
	opacity: 0.9;
	cursor: pointer;

	animation-name: resize;
	animation-duration: 1s;
	animation-iteration-count: infinite;
	animation-direction: alternate;
	animation-timing-function: ease-in-out;
}

@keyframes resize {
  0% {
    background-color:darkblue;
  }
  100% {
    background-color:darkred;
  }
}

</style>
